import React from "react";
import { getRevisionsListAsync } from "editor/actions/revisions";
import PropTypes from "prop-types";

class ComponentWithRevisions extends React.Component {
  componentDidMount() {
    if (
      this.props.revisions.requestRevisions &&
      this.props.form &&
      this.props.form.id
    ) {
      this.props.getRevisionsListAsync(this.props.form.id);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.revisions && nextProps.revisions.requestRevisions) {
      if (
        this.props.revisions.requestRevisions !==
        nextProps.revisions.requestRevisions
      ) {
        this.props.getRevisionsListAsync(nextProps.form.id);
      }

      if (this.props.form.id !== nextProps.form.id) {
        this.props.getRevisionsListAsync(nextProps.form.id);
      }
    }
  }
}

export const mapStateToProps = state => ({
  revisions: state.editor.revisions,
});

export const mapDispatchToProps = {
  getRevisionsListAsync,
};

ComponentWithRevisions.propTypes = {
  form: PropTypes.object.isRequired,
  getRevisionsListAsync: PropTypes.func.isRequired,
  revisions: PropTypes.object.isRequired,
};

export default ComponentWithRevisions;
